module.exports = __webpack_public_path__ + "static/img/company-search-logo-light.8d6a7f30.png";